import { render, staticRenderFns } from "./EducationMobile.vue?vue&type=template&id=5cecf388&scoped=true&"
import script from "./EducationMobile.vue?vue&type=script&lang=js&"
export * from "./EducationMobile.vue?vue&type=script&lang=js&"
import style0 from "./EducationMobile.vue?vue&type=style&index=0&id=5cecf388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecf388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cecf388')) {
      api.createRecord('5cecf388', component.options)
    } else {
      api.reload('5cecf388', component.options)
    }
    module.hot.accept("./EducationMobile.vue?vue&type=template&id=5cecf388&scoped=true&", function () {
      api.rerender('5cecf388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Education/EducationMobile.vue"
export default component.exports